// React
import React, { useState, useEffect, useContext } from 'react'
import { Link, useHistory } from 'react-router-dom'

// Context
import AuthContext from '../../authContext'

// Redux
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Store } from '../../redux/reducers'
import {
  getLogsAction,
  getParcelsWithIdAction,
  getParcelInventoryItemsAction,
  cleanPercelInventoryItemsAction,
  getInventoryItemsWithSerialAction
} from '../parcels/actions'

// Selector
import { createStructuredSelector } from 'reselect'
import {
  makeSelectLogs,
  makeSelectParcel,
  makeSelectLoading,
  makeSelectError,
  makeSelectInventoryItemsList,
  makeSelectInventoryItemsLoading,
  makeSelectInventoryItemsCount,
  makeSelectInventoryItemsWithSerialList,
  makeSelectInventoryItemsWithSerialLoading
} from '../parcels/selectors'

//UI
import theme from '../../theme'
import {
  Typography,
  Grid,
  Button,
  CircularProgress,
  Box,
  ClickAwayListener,
  Card,
  CardContent,
  Dialog,
  DialogTitle
} from '@material-ui/core'
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot
} from '@material-ui/lab'

// Components
import ListParcelItems from './list'
import Can from '../../components/Can'
import CSV from './csv'
import InventoryItemCSV from './inventoryItemCsv'
import LabelList from '../parcelInventoryItems/components/labelsList'
import Modal from '../../components/Modal'
import ProductRepository from 'client-sdk/src/Repository/product-repository'
import getParcelFileReq from 'client-sdk/src/parcels/file'

// Helper
import { translate, removeEmptyValueObject } from '../../utils/helpers'
import jMoment from 'moment-jalaali'

// Type
import { SelectorProps, Props } from './interfaces'
import Pagination from '@material-ui/lab/Pagination'
import RenderFilter, { Filter } from '../../utils/listDaynamicFilter'
import clsx from 'clsx'
import useQuery from '../../utils/hook/useQuery'
import classes from './index.module.scss'
import { getCatAction } from '../orders/actions'
import TPSRepository from 'client-sdk/src/Repository/tps-management-repository'

import handleNotfication from '../../utils/handleNotfication'
import handleError from '../../utils/handleError'
import { makeSelectCatList } from '../orders/selectors'
import RonadIcons from '../../components/iconComponent'
import { CustomizedItems } from '../../components/customizedItems'
import OptionsModal from '../products/components/optionsModal'
import CreateTicket from '../ticketing/components/registerTicket'
import { getAllTicket } from '../../api/ticket/get'
import { Log } from '../orders/interfaces'

const iconStatus = {
  ARRIVED: 'mapMarker', //'به مقصد رسیده',
  CANCELLED: 'times', //'لغو شده',
  SHIPPED: 'circleMedium', //'ارسال شده',
  DELIVERED: 'listCheck', //'تحویل داده شده',
  SUBMITTED: 'circleMedium', //'ایجاد شده',
  ASSIGNED: 'listCheck', // تخصیص داده شده
  REGISTERED: 'check', //'منطبق شده',
  CONFLICTED: 'conflict', // مغایرت داده شده
  LOCATED: 'fileTree', // جایگذاری شده
  RETURNING: 'undo', // ریجکت شده
  UNLOADING: 'tableArrowUp', // در حال بارگذاری
  UNLOADED: 'listCheck', // تخلیه شده
  PICKED: 'packageVariant',
  NOT_REGISTERED: 'cubeOutline',
  CHECKED: 'packageVariantClosed',
  RECEIPT_TO_WASTAGE: 'circleMedium',
  RECEIPT_FROM_WASTAGE: 'circleMedium',
  RESOLVED_BY_RONAD: 'circleMedium'
}
const colorStatus = {
  SUBMITTED: theme.palette.green.main, //'ثپت شده',
  SHIPPED: theme.palette.green.main, //'ارسال شده',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  REGISTERED: theme.palette.green.main, //'منطبق شده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  RETURNING: theme.palette.warning.main, //'ریجکت شده',
  UNLOADING: theme.palette.orange.main, //'در حال بارگذاری ',
  UNLOADED: theme.palette.green.main, //'تخلیه شده',
  LOCATED: 'purple', // جایگذاری شده
  ASSIGNED: theme.palette.blue.main, // تخصیص داده شده
  CONFLICTED: theme.palette.orange.main // مغایرت داده شده
}

export function Details(props: Props) {
  const authContext = useContext(AuthContext)
  const [filters, setFilters] = useState([] as Filter[])
  const { filtersValues, setFiltersValues } = useQuery(
    {
      parcelId: { equals: props.match.params.id },
      page: 0,
      size: 400
    } as any,
    ''
  )
  const history = useHistory()
  const [printModal, setPrintModal] = useState(false as boolean)
  const [openFilterBox, setOpenFilterBox] = React.useState(false)
  const [selected, setSelected] = React.useState<string[]>([])
  const [oldTicket, setOldTicket] = useState([])
  const [openMsg, setOpenMsg] = useState(false)
  const [modal, setModal] = useState('')
  const [selectedItems, setSelectedItems] = useState([])
  const [conflicts, setConflicts] = useState([])

  const handleCloseModal = () => {
    setOpenMsg(false)
  }

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'productName.contains',
        label: 'نام کالا',
        icon: 'box'
      },
      {
        type: 'input',
        id: 'productCode.contains',
        label: 'کد کالا',
        icon: 'key'
      },
      {
        type: 'number',
        id: 'productId.equals',
        label: 'شناسه کالا',
        icon: 'key'
      },
      {
        type: 'number',
        id: 'skuId.equals',
        label: 'شناسه تنوع کالا',
        icon: 'key'
      },
      {
        type: 'input',
        id: 'skuCode.contains',
        label: 'کد تنوع کالا',
        icon: 'key'
      },
      {
        type: 'input',
        id: 'serialNumber.equals',
        label: 'سریال کالا',
        icon: 'key'
      }
    ])
  }

  useEffect(() => {
    const { id } = props.match.params
    // setValue("parcel-order-id", id);
    props.getLogsDispatch(id)
    props.getParcelWithIdActionDispatch(id)
    getOldTicket(id)
    // props.getInventoryItemsWithSerialActionDispatch({
    //   ...filtersValues,
    // });
    return () => {
      props.clearnParcelInventoryItemsDispatch()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.getParcelInventoryItemDispatch({
      ...filtersValues
    })
    setupFilters()
  }, [filtersValues])

  useEffect(() => {
    if (props.parcel?.conflicts?.length > 0) {
      getConflictsSkus()
    }
  }, [props.parcel])

  const getOldTicket = async (id: number) => {
    try {
      const res = await getAllTicket({ linkType: 'parcel', linkId: id })
      setOldTicket(res.data.content)
    } catch (error) {
      handleError(error)
    }
  }

  const getConflictsSkus = async () => {
    const ids = props.parcel.conflicts.map((el) => el.skuId)
    try {
      const { response } = await ProductRepository.getVariant({
        payload: {
          params: {
            'id.in': ids
          }
        }
      })

      setConflicts(
        response.data.content.map((el) => {
          return {
            ...el,
            ...props.parcel?.conflicts.filter((con) => con.skuId == el.id)[0]
          }
        })
      )
      // setConflicts(response.data.content)
    } catch (error) {
      console.log(error)
      handleError(error)
    }
  }

  const handleClickFilter = () => {
    setOpenFilterBox((prev) => !prev)
  }

  useEffect(() => {
    setFiltersValues({
      parcelId: { equals: props.match.params.id },
      page: 0,
      size: 400
    })
  }, [printModal])

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
        'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false)
  }

  const handleOpenPrintModal = () => {
    setPrintModal(true)
  }

  const handleClosePrintModal = () => {
    setPrintModal(false)
  }

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 })
  }

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.inventoryItems.map((n: any) => n.id)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleClickPrint = () => {
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(',')}`
    )
  }

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id)
    let newSelected: string[] = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      )
    }

    setSelected(newSelected)
  }

  const updateInventory = async () => {
    const items = props.parcel.items.filter((el) =>
      selectedItems.includes(el.id)
    )
    const productIds = items.map((el) => el.inventoryItems[0]?.productId)
    try {
      await TPSRepository.updateListOfProductInventory({
        payload: {
          ronadProductIds: productIds
        }
      })
      setModal('')
      handleNotfication(
        'عملیات همگام سازی امکان دارد کمی زمان بر باشد.',
        'success'
      )
    } catch (error) {
      handleError(error)
    }
  }

  const selectAll = (e: any) => {
    if (e.target.checked) {
      setSelectedItems(props.parcel.items.map((el) => el.id))
    } else {
      setSelectedItems([])
    }
  }

  const selectItem = (e: any, id: string) => {
    if (e.target.checked) {
      setSelectedItems((prev) => [...prev, id])
    } else {
      setSelectedItems((prev) => prev.filter((el) => el !== id))
    }
  }

  const downloadDigiFile = async () => {
    try {
      const response = await getParcelFileReq(props.parcel.id)
      const file = URL.createObjectURL(response.blob)
      const link = document.createElement('a')
      link.href = file
      link.setAttribute('download', props.parcel?.labelFileName)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <div className={classes.root}>
      <Typography variant='h6' component='h2' style={{ marginBottom: '24px' }}>
        <Button onClick={() => history.goBack()}>
          <RonadIcons name='chevronRight' />
        </Button>
        {`جزيیات محموله`}
        <span data-cy='parcelId'> {props.parcel.id}</span>
      </Typography>
      <Grid
        container
        style={{
          marginBottom: '32px',
          backgroundColor: '#fff',
          padding: '24px'
        }}
      >
        <Grid item lg={12} md={12} xs={12} spacing={2}>
          <p className='typography-cards'>لیست کالاهای محموله</p>
          <div
            style={{
              textAlign: 'left',
              display: 'flex',
              alignItems: 'stretch',
              marginBottom: '24px'
            }}
          >
            {/* <Button
              variant="contained"
              size="large"
              color="primary"
              onClick={() => setModal("SYNC_OPTIONS")}
              style={{ marginLeft: 'auto' }}
              disabled={selectedItems.length === 0}
            >
              <RonadIcons name='sync' title='همگام‌سازی موجودی بازارگاه' />
            </Button> */}
            {oldTicket.length === 0 ? (
              <Button
                variant='contained'
                size='large'
                color='primary'
                onClick={() => setOpenMsg(true)}
                style={{ marginLeft: '5px' }}
              >
                {`تیکت جدید`}
              </Button>
            ) : (
              <Link to={`/alltickets/helpical/detail/${oldTicket[0].id}`}>
                <Button
                  variant='contained'
                  size='large'
                  color='primary'
                  style={{ marginLeft: '5px' }}
                >
                  {`سابقه تیکت`}
                </Button>
              </Link>
            )}
            <Can
              role={authContext.user.role}
              perform='/parcels/receipts/:id'
              yes={() => (
                <Link
                  to={`/parcels/receipts/${props.parcel.id}`}
                  target='_blank'
                  style={{ textDecoration: 'none' }}
                >
                  <Button
                    style={{ marginLeft: '5px' }}
                    variant='contained'
                    color='secondary'
                    data-cy='printReceipts'
                    size='large'
                  >
                    {authContext.user.role === 'WAREHOUSE_OPERATOR' ||
                    authContext.user.role === 'WAREHOUSE_ADMIN'
                      ? 'چاپ رسید'
                      : 'چاپ حواله'}
                  </Button>
                </Link>
              )}
            />
            <Can
              perform='parcels-details:print'
              role={authContext.user.role}
              yes={() => (
                <Button
                  variant='contained'
                  color='primary'
                  size='large'
                  onClick={handleOpenPrintModal}
                  style={{ marginLeft: '5px' }}
                  data-cy='printId'
                >
                  {'چاپ سریال'}
                </Button>
              )}
            />
            <Can
              role={authContext.user.role}
              perform='parcels-detail:downloadInventoryItemCSV'
              yes={() => (
                <>
                  {props.inventoryItemsWithSerial?.length && (
                    <InventoryItemCSV
                      ordersDispatch={
                        props.getInventoryItemsWithSerialActionDispatch
                      }
                      data={props.inventoryItemsWithSerial}
                      filtersValues={filtersValues}
                      loading={props.inventoryItemsWithSerialLoading}
                    />
                  )}
                </>
              )}
            />
            <Can
              role={authContext.user.role}
              perform='parcels-detail:downloadCSV'
              yes={() => (
                <>
                  {props.parcel?.items?.length && (
                    <CSV
                      ordersDispatch={props.getParcelInventoryItemDispatch}
                      data={props.parcel?.items}
                      filtersValues={filtersValues}
                      loading={props.inventoryItemsLoading}
                    />
                  )}
                </>
              )}
            />
          </div>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            props.parcel?.items && (
              <>
                <ListParcelItems
                  data={props.parcel.items.filter((el) => !el.hasConflict)}
                  selectAll={selectAll}
                  selectItem={selectItem}
                  selectedItems={selectedItems}
                  hasConflict={props.parcel.hasConflict}
                  conflicts={conflicts}
                />
              </>
            )
          )}
          <Grid
            xs={12}
            container
            justify='space-between'
            alignItems='center'
            style={{ marginBottom: '24px' }}
          >
            <Pagination
              count={Math.ceil(props.inventoryItemsCount / filtersValues.size)}
              color='secondary'
              page={filtersValues.page + 1}
              onChange={handleChangePage}
            />
          </Grid>
          <p className='typography-cards'>اطلاعات محموله</p>
          <Card style={{ marginBottom: '24px' }}>
            <CardContent style={{ paddingBottom: '0' }}>
              <Grid container>
                <Grid item xs={12} sm={4}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'شناسه محموله:  '}</span>
                    <span data-cy='parcelStatus'>{props.parcel.id}</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'زمان تحویل محموله:  '}
                    </span>
                    <span>
                      <span data-cy='deliveryDate'>
                        {props.parcel.deliveryDate &&
                          `${jMoment(props.parcel.shippingDate, 'YYYY/MM/DD')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD')}`}
                      </span>
                    </span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'تعداد آیتم های محموله:  '}
                    </span>
                    <span data-cy='inventoryItemsCount'>
                      {props.inventoryItemsCount}
                    </span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'نام مسئول حمل:  '}</span>
                    <span data-cy='parcelSellerName'>
                      {props.parcel?.agentName}
                    </span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'شماره تماس مسئول حمل:  '}
                    </span>
                    <span data-cy='parcelId'>
                      {props.parcel.agentPhoneNumber}
                    </span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'نوع ورود:'}</span>
                    <span data-cy='parcelId'>
                      {props.parcel.fulfillmentTypeName}
                    </span>
                  </div>
                </Grid>
                {props.parcel.fulfillmentTypeEnabled && (
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>{'نوع ارسال:'}</span>
                      <span data-cy='parcelId'>{props.parcel.courierName}</span>
                    </div>
                  </Grid>
                )}
                <Grid item xs={12} sm={4}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'تعداد بسته:'}</span>
                    <span style={{ flex: 1, maxWidth: '150px' }}>
                      {props.parcel?.parcelPackages?.map((el: any) => (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                          }}
                        >
                          <span className='ml-1'>{el?.count}</span>
                          <span className='ml-1'>{`${el.length}×${el.height}×${el.width}`}</span>
                          <span>{el.weight}</span>
                        </div>
                      ))}
                    </span>
                  </div>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'توضیحات:  '}</span>
                    <span data-cy='itemsLength'>
                      {props.parcel?.description}
                    </span>
                  </div>
                </Grid>
                {props.parcel?.labelFileName && (
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        {'فایل دیجی‌کالا:  '}
                      </span>
                      <span
                        data-cy='file-link'
                        className='link'
                        onClick={downloadDigiFile}
                      >
                        {props.parcel?.labelFileName}
                      </span>
                    </div>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
          <p className='typography-cards'>خدمات مازاد</p>
          <CustomizedItems
            getParcelWithId={(id: number) =>
              props.getParcelWithIdActionDispatch(id)
            }
            id={props.match.params.id}
            parcel={props.parcel}
          />
          <p className='typography-cards'>تاریخچه محموله</p>
          <Card>
            <CardContent>
              <Grid container style={{ padding: '0' }}>
                <Grid item xs={12}>
                  <Timeline
                    align='left'
                    style={{
                      minWidth: '500px',
                      margin: 0,
                      padding: 0
                    }}
                  >
                    {props.logs
                      ?.slice()
                      .reverse()
                      .map((log: Log, index: number) => (
                        <TimelineItem
                          className={classes.missingOppositeContent}
                          key={index}
                          data-cy='timeLineItem'
                        >
                          <TimelineSeparator>
                            <TimelineDot
                              style={{
                                backgroundColor: colorStatus[log.newStatus],
                                border: index === 0 ? 'solid 4px #DF9234' : '',
                                marginTop: '12px'
                              }}
                            >
                              <RonadIcons
                                name={iconStatus[log.newStatus]}
                                size={1}
                                className='text-white'
                              />
                            </TimelineDot>
                            {index !== props.logs?.length - 1 ? (
                              <TimelineConnector />
                            ) : (
                              ''
                            )}
                          </TimelineSeparator>
                          <TimelineContent className={classes.paperHistory}>
                            <div style={{ padding: '10px' }}>
                              <div className={classes.contentBox}>
                                <div style={{ flex: 2, textAlign: 'right' }}>
                                  <span className={classes.contentlabel}>
                                    وضعیت محموله:
                                  </span>
                                  <span data-cy='logStatus'>
                                    {translate(log.newStatus, 'parcel')}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    textAlign: 'right',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <span className={classes.contentlabel}>
                                    کاربر:
                                  </span>
                                  <Can
                                    role={authContext.user.role}
                                    perform='user-name:dontShowInLogs'
                                    no={() => (
                                      <>
                                        <span>{log.modifierName}</span>
                                        <span>
                                          {' '}
                                          &nbsp; &nbsp;- &nbsp; &nbsp;
                                        </span>
                                      </>
                                    )}
                                  />
                                  <span data-cy='userRole'>
                                    {translate(log.modifierRole, 'user')}
                                  </span>
                                </div>
                                <Typography
                                  component='div'
                                  className={classes.titleBox}
                                  style={{ flex: 1 }}
                                  data-cy='logTime'
                                >
                                  {log.time &&
                                    jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                      .locale('fa')
                                      .format('jYYYY/jMM/jDD - HH:mm')}
                                </Typography>
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      {/*REFACTOR Extract dialoue*/}
      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby='responsive-dialog-title'
        maxWidth='sm'
        fullWidth
        style={{ padding: '16px' }}
      >
        <DialogTitle>
          <Grid container justifyContent='center' justify='center'>
            <p style={{ marginTop: '-8px' }}>ایجاد تیکت جدید</p>
          </Grid>
        </DialogTitle>

        <Grid container direction='column'>
          <CreateTicket
            handleCloseModal={handleCloseModal}
            linkId={props.match.params.id}
            linkType='parcel'
          />
        </Grid>
      </Dialog>

      <Modal
        maxWidth='xl'
        onClose={handleClosePrintModal}
        open={printModal}
        title={
          <div style={{ textAlign: 'center' }}>
            <RonadIcons name='printer' className='text-green' size={4} />
          </div>
        }
        content={
          <Grid container>
            <Grid
              container
              justify='flex-end'
              item
              xs={12}
              style={{ marginBottom: '5px' }}
            >
              <ClickAwayListener onClickAway={handleClickAway}>
                <div>
                  <Button
                    type='button'
                    onClick={handleClickFilter}
                    className={classes.iconButton}
                    aria-label='search'
                  >
                    {openFilterBox ? 'بستن' : 'جستجوی پیشرفته'}
                  </Button>
                  {openFilterBox ? (
                    <div
                      className={clsx(classes.filterBox, {
                        [classes.filterOpen]: openFilterBox
                      })}
                    >
                      <RenderFilter
                        filters={filters}
                        onFilter={(filtervalues: any) => {
                          setFiltersValues({
                            ...removeEmptyValueObject(filtervalues),
                            parcelId: { equals: props.match.params.id },
                            page: 0,
                            size: 400
                          })
                          setOpenFilterBox(false)
                        }}
                        setOpenFilterBox={setOpenFilterBox}
                      />
                    </div>
                  ) : null}
                </div>
              </ClickAwayListener>
            </Grid>
            <Grid xs={12} style={{ marginBottom: '20px', marginTop: '20px' }}>
              <LabelList
                selected={selected}
                handleSelectAllClick={handleSelectAllClick}
                handleClick={handleClick}
                data={props.inventoryItems}
              />
            </Grid>
            <Box mb={4} />
            <Grid xs={12} container justify='space-between' alignItems='center'>
              <Pagination
                count={Math.ceil(
                  props.inventoryItemsCount / filtersValues.size
                )}
                color='secondary'
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <Button
                disabled={selected.length < 1}
                variant='contained'
                color='secondary'
                size='large'
                onClick={handleClickPrint}
                startIcon={
                  <RonadIcons name='printer' className='text-white' size={1} />
                }
              >
                {'پرینت سریال‌ها'}
              </Button>
            </Grid>
          </Grid>
        }
      />

      <Modal
        maxWidth='lg'
        onClose={() => setModal('')}
        open={modal == 'SYNC_OPTIONS'}
        content={
          <React.Fragment>
            <OptionsModal changeOptionState={updateInventory} />
          </React.Fragment>
        }
      />
    </div>
  )
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  catList: makeSelectCatList(),
  parcel: makeSelectParcel(),
  loading: makeSelectLoading(),
  inventoryItemsCount: makeSelectInventoryItemsCount(),
  inventoryItemsWithSerial: makeSelectInventoryItemsWithSerialList(),
  inventoryItemsWithSerialLoading: makeSelectInventoryItemsWithSerialLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsList(),
  inventoryItemsLoading: makeSelectInventoryItemsLoading()
})

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    getCatDispatch: (payload: any) => dispatch(getCatAction(payload)),
    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({ id })),
    getParcelInventoryItemDispatch: (payload: object) =>
      dispatch(getParcelInventoryItemsAction(payload)),
    clearnParcelInventoryItemsDispatch: () =>
      dispatch(cleanPercelInventoryItemsAction()),
    getInventoryItemsWithSerialActionDispatch: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload))
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
export default compose(withConnect)(Details)
